import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInMonths,
  differenceInWeeks,
  differenceInYears,
} from 'date-fns'

// Largest unit first: the first one with a whole count names the age.
export const BIRDVIEW_RELATIVE_TIME_UNITS = [
  {
    getDifference: differenceInYears,
    key: 'DashboardBirdview.RelativeTimeYearsKey',
  },
  {
    getDifference: differenceInMonths,
    key: 'DashboardBirdview.RelativeTimeMonthsKey',
  },
  {
    getDifference: differenceInWeeks,
    key: 'DashboardBirdview.RelativeTimeWeeksKey',
  },
  {
    getDifference: differenceInDays,
    key: 'DashboardBirdview.RelativeTimeDaysKey',
  },
  {
    getDifference: differenceInHours,
    key: 'DashboardBirdview.RelativeTimeHoursKey',
  },
  {
    getDifference: differenceInMinutes,
    key: 'DashboardBirdview.RelativeTimeMinutesKey',
  },
]

export const BIRDVIEW_RELATIVE_TIME_NOW_KEY =
  'DashboardBirdview.RelativeTimeNowKey'
